import pageMeta from '../data/page-meta.json';
import discovery from './publicDiscovery.js';

// Browser updates and generated HTML use one canonical metadata implementation.
export const PAGE_META = pageMeta;
export const SITE_ORIGIN = discovery.SITE_ORIGIN;
export const absoluteShareUrl = discovery.absoluteUrl;
export const absoluteShareImage = discovery.absoluteShareImage;
export const buildSocialMetaTags = discovery.buildSocialMetaTags;
